const menuPage = {
  'menuPage-title': 'Unsere Speisekarte'
};

export default menuPage;
